import MedicalConclusion from "./medical-conclusion";
export default MedicalConclusion;
